// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs-module--tabs--FLCUH","labels":"Tabs-module--labels--1Tk6G","label":"Tabs-module--label--3p4_z"};